/* eslint-disable no-undef */
import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import {DISABLE_ERROR, KEYS, UNVERIFIED_ERROR} from './Constants';
import {getData, storeData} from './GeneralStorage';
import {BASE_URL} from './URLConstants';

export const PAGE_SIZE = 12;
export const NERWORK_ERROR =
  'It looks like your device is having trouble connecting to a network. Please check your network settings and try again.';

//Constants for token error, only used from here
export const TOKEN_ERROR_1 = 'Invalid token or token is expired';
export const TOKEN_ERROR_2 = 'jwt expired';

// use this only for calling diathrive backend apis since this was configured with refresh auth logic
export const axiosInstanceWithDiathriveAuth = axios.create({
  headers: {
    'content-type': 'application/json',
  },
  responseType: 'json',
});

// use this for calling public apis
export const axiosInstance = axios.create({
  headers: {
    'content-type': 'application/json',
  },
  responseType: 'json',
});

export const refreshAuthLogic = async failedRequest => {
  if (!failedRequest.config.url.includes('patients/mobile-web-login')) {
    const data = await getData(KEYS.userInfo);
    if (data) {
      try {
        const {email, id, refreshToken} = JSON.parse(data);
        return axiosInstance
          .post(`${BASE_URL}patients/refresh-token`, {
            email,
            id: Number(id),
            refreshToken,
          })
          .then(async res => {
            await storeData(KEYS.userToken, res.data.data.accessToken);
            failedRequest.response.config.headers.Authorization = `Bearer ${res.data.data.accessToken}`;
            return Promise.resolve();
          })
          .catch(error => {
            localStorage.removeItem(KEYS.userInfo);
            localStorage.removeItem(KEYS.userToken);
            localStorage.removeItem(KEYS.isLogin);
            localStorage.removeItem(KEYS.userId);
            return Promise.reject(error);
          });
      } catch (error) {
        return Promise.reject(error);
      }
    }
    return Promise.reject(failedRequest);
  } else {
    return Promise.reject(failedRequest);
  }
};

export const configureAxios = triggerLogin => {
  axiosInstanceWithDiathriveAuth.defaults.timeout = 15000; // 15 Seconds timeout
  axiosInstanceWithDiathriveAuth.defaults.baseURL = BASE_URL; // the prefix of the URL
  axiosInstanceWithDiathriveAuth.defaults.headers.common.Accept =
    'application/json'; // default header for all get request
  axiosInstanceWithDiathriveAuth.interceptors.request.use(
    async config => {
      const token = await getData(KEYS.userToken);
      if (token) {
        config.headers.Authorization = 'Bearer ' + token;
      }
      return config;
    },
    error => Promise.reject(error),
  );

  createAuthRefreshInterceptor(
    axiosInstanceWithDiathriveAuth,
    refreshAuthLogic,
    {
      statusCodes: [401],
    },
  );
  axiosInstanceWithDiathriveAuth.interceptors.response.use(
    response => response,
    errorMsg => {
      // if (errorMsg.response && errorMsg.response.status === 401) {
      //   DLog('Delete User data like token, user details and reirect to login');
      //   return Promise.reject(errorMsg.response);
      // }
      // console.log('unfiltered errror', errorMsg, errorMsg.response);
      if (errorMsg && errorMsg.response && errorMsg.response.data) {
        if (
          errorMsg.response.status === 401 &&
          !errorMsg.response.config.url.includes('patients/mobile-web-login')
        ) {
          triggerLogin();
        }
        const error = errorMsg.response.data;
        if (errorMsg.response.status == 422) {
          return Promise.reject({
            data: errorMsg.response.data,
            status: errorMsg.response.status,
          });
        } else if (error) {
          if (error.errors instanceof Array) {
            return Promise.reject(error.errors[0].message);
          } else if (error.errors instanceof Object) {
            if (
              error.errors.message === 'Duplicate data.' ||
              error.errors.message === DISABLE_ERROR ||
              error.errors.message === UNVERIFIED_ERROR
            ) {
              //Important for glucose data sync.
              return Promise.reject(error.errors);
            }
            return Promise.reject(error.errors.message);
          } else if (typeof error.errors === 'string') {
            return Promise.reject(error.errors);
          }
        }
        return Promise.reject(errorMsg);
      } else if (errorMsg && errorMsg.message === 'Network Error') {
        console.log(NERWORK_ERROR);
        return Promise.reject(NERWORK_ERROR);
      }
      return Promise.reject(errorMsg && errorMsg.message);
    },
  );
};

export const fetchApi = (method, url, body, params, headers) => {
  let config = {
    method: method,
    url: url,
  };
  if (headers) {
    config.headers = headers;
  }
  if (body) {
    config.data = body;
  }
  if (params) {
    config.params = params;
  }
  return axiosInstanceWithDiathriveAuth(config);
};

export const formDataRequest = async (method, url, body) => {
  const token = await getData(KEYS.userToken);
  const uri = BASE_URL + url;

  // DLog({
  //   body: body,
  //   method: method.toUpperCase(),
  //   headers: {
  //     Authorization: 'Bearer ' + token,
  //   },
  // });
  return fetch(uri, {
    body: body,
    method: method.toUpperCase(),
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
};

export const parseError = e => {
  let err = '';
  if (e.response && e.response.data) {
    const error = e.response.data;
    if (error) {
      if (error.errors instanceof Array) {
        err = error.errors[0].message;
      } else if (error.errors instanceof Object) {
        return Promise.reject(error.errors.message);
      } else if (typeof error.errors === 'string') {
        err = error.errors;
      }
    }
    err = e.message;
  } else if (e.message === 'Network Error') {
    //console.log(NERWORK_ERROR);
    err = NERWORK_ERROR;
  }
  err = e.message;
  return err;
};
